import { Heading, Link } from "@icg360/design-system";

import { usePolicyFeature } from "utils/policy-feature-map";

import styles from "./ss1.module.scss";

export const SageSureOneCard = () => {
  const show = usePolicyFeature("sageSureOneDisplay");
  if (!show) return null;
  return (
    <div className={styles.card}>
      <img
        className={styles.logo}
        src="/assets/images/ss1-one.svg"
        alt="SageSure One"
      />
      <Heading size="sm">You have a dedicated SageSure One Consultant</Heading>
      <p>
        Your One Consultant is here for you, ready to help with policy
        questions, claims support, inspections, and loss mitigation services.
      </p>
      <ul className={styles.contactList}>
        <li>
          <Link leadingIcon="Chat">Chat with your consultant</Link>
        </li>
        <li>
          <Link leadingIcon="PhoneCall">1-855-302-4648</Link>
        </li>
        <li>
          <Link leadingIcon="Email">one@connect.sagesure.com</Link>
        </li>
      </ul>
    </div>
  );
};
